import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Zone } from '../../models/zone';
import { UsageRate, UsageRateZone } from '../../models/usage-rate';

@Component({
  selector: 'app-create-usage-rate-zone-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule],
  templateUrl: './create-usage-rate-zone-dialog.html',
  styleUrl: './create-usage-rate-zone-dialog.css',
})
export class CreateUsageRateZoneDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreateUsageRateZoneDialog>,
    @Inject(MAT_DIALOG_DATA) public usageRate: UsageRate
  ) { }

  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  public zones!: Zone[];

  usageRateZoneForm = this._formBuilder.group({
    zone: ['', Validators.required],
    price: [0.0000, Validators.required]
  });

  ngOnInit() {
    this.backendApi.getZones().subscribe({
      next: (zones) => {
        this.zones = zones;
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la recuperation des zones.");
      }
    });
  }

  submit() {
    const usageRateZone: UsageRateZone = this.usageRateZoneForm.value as UsageRateZone;

    this.backendApi.createUsageRateZone(this.usageRate.uuid, usageRateZone).subscribe({
      next: (response) => {
        this._snackBar.open("Entrée ajoutée.");
        this.dialogRef.close(response);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée.");
      }
    })
  }
}
